const PRODUCT_TYPES_INELIGIBLE_FOR_MEMBERSHIP = [
  'Membership',
  'Donation',
  'FlaggedBook',
  'GiftCard',
  'Bookclub',
  'GiftSubscription',
];

/**
 * Automatically adds the membership product to a users cart if:
 * 1. They haven't removed it from their cart before
 * 2. The membership is not in their cart
 */

window.MembershipAutoDedupe = async () => {
  await fetch(`${window.Shopify.routes.root}cart.js`)
    .then((response) => response.json())
    .then((response) => {
      window.Allstora.cart = response;
    });

  const membershipInCart =
    window.Allstora.cart.items.some((item) => item.id === window.Allstora.membership.variant_id) ||
    window.Allstora.cart.items.some((item) => item.id === window.Allstora.membership_yearly.variant_id);

  const bookclubInCart = window.Allstora.cart.items.some((item) => item.product_type === 'Bookclub');

  if (bookclubInCart && membershipInCart) {
    $('.cart-remove-button[data-variant-id=' + window.Allstora.membership.variant_id + ']').trigger('click');
    $('.cart-remove-button[data-variant-id=' + window.Allstora.membership_yearly.variant_id + ']').trigger('click');
  }
};

window.addEventListener('DOMContentLoaded', () => {
  window.MembershipAutoDedupe();
});
